"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import type { MenuMilestone } from "@growwithai/shared";
import { recordMenuVisit } from "@/lib/api-client";
const PATH_TO_MILESTONE: [string, MenuMilestone][] = [["/my-classes", "visited_my_classes"], ["/community", "visited_community"], ["/tools", "visited_tools"], ["/bonuses", "visited_bonuses"]];
const SESSION_PREFIX = "gwai_ms_";

// Guard ganda (module Set + sessionStorage) → maksimal 1 POST per milestone per session
const sent = new Set<string>();

/**
 * Catat kunjungan menu utama untuk checklist onboarding.
 * Dipanggil sekali di UserDashboardLayout — semua sub-route otomatis tercakup.
 */
export function useMenuVisit() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!pathname) {
        return;
      }
      const hit = PATH_TO_MILESTONE.find(t2 => {
        const [prefix] = t2;
        return pathname.startsWith(prefix);
      });
      if (!hit) {
        return;
      }
      const milestone = hit[1];
      if (sent.has(milestone)) {
        return;
      }
      try {
        if (sessionStorage.getItem(SESSION_PREFIX + milestone)) {
          sent.add(milestone);
          return;
        }
        sessionStorage.setItem(SESSION_PREFIX + milestone, "1");
      } catch {}
      sent.add(milestone);
      recordMenuVisit(milestone);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}